import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import { format, parseISO } from 'date-fns';
import classes from '@nerdwallet/base-styles/classes';
import { Link } from '../Link/Link';
import { Type } from '../Type/Type';

/**
 * If date parsing fails, don't mount 'Invalid Date'.
 *
 * @param authoringDate ISO8601 date string.
 * @returns null or formatted date string.
 */
var getDate = function getDate(authoringDate) {
  try {
    return format(parseISO(authoringDate), 'PP');
  } catch (e) {
    return null;
  }
};

var renderDelimiter = function renderDelimiter(index, authors) {
  return index === authors.length - 1 ? '' : ', ';
}; // Alternate between Link and Type elements depending on if authors supply an href


var renderAuthors = function renderAuthors(authors) {
  return authors && authors.map(function (author, index) {
    return author.url ? /*#__PURE__*/React.createElement("span", {
      key: author.name
    }, /*#__PURE__*/React.createElement(Link, {
      size: 1,
      href: author.url
    }, author.name), /*#__PURE__*/React.createElement(Type, {
      color: "neutral-darkest",
      inline: true,
      gotham: true,
      size: 1
    }, renderDelimiter(index, authors))) : /*#__PURE__*/React.createElement(Type, {
      key: author.name,
      color: "neutral-darkest",
      inline: true,
      gotham: true,
      size: 1
    }, author.name, renderDelimiter(index, authors));
  });
};

export var AuthorByline = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var authors = props.authors,
      authoringDate = props.authoringDate;
  return /*#__PURE__*/React.createElement("span", {
    ref: ref
  }, renderAuthors(authors), authoringDate && /*#__PURE__*/React.createElement(Type, {
    className: classes('margin-left-3'),
    light: true,
    gotham: true,
    inline: true,
    size: 1
  }, getDate(authoringDate)));
});
AuthorByline.displayName = 'AuthorByline';